/* === STORYTELLER HEADER SCROLL EFFECT === */
/* Adds 'scrolled' class to header when user scrolls down */

(function () {
  var header =
    document.querySelector('.header-wrapper') ||
    document.querySelector('.shopify-section-header') ||
    document.querySelector('header');

  if (!header) return;

  var THRESHOLD = 50; // distance in pixels before changing header

  function updateHeader() {
    if (window.scrollY > THRESHOLD) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  window.addEventListener('load', updateHeader, { passive: true });
  document.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader, { passive: true });
})();
